import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin, map, Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1120pcSchFService {

  constructor(private http: HttpClient) { }

  // CRITICAL: Service Method Signature for saving form data
  saveF1120pcSchFForm(
    baseUrl: string,
    mainData: any[],
    diagData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {

    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);

    // Essential parameters with fallbacks - match AngularJS exactly
    params.jsonSettings = JSON.stringify({
      "tax_year": rowData.TAX_YEAR,
      "scenario": rowData.SCENARIO,
      "jcd_key": rowData.JCD_KEY,
      "combination_key": rowData.COMBINATION_KEY,
      "trans_type_key": mainData[0].editrows[0][0].trans_type_key
    });
    params.jsonObj = JSON.stringify(mainData);
    params.tax_year = filterParams.tax_year || params.tax_year || rowData.TAX_YEAR;
    params.scenario = filterParams.scenario || params.scenario || rowData.SCENARIO;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || rowData.JCD_KEY || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    params.process_name = filterParams.process_name || "1120PC Sch F";
    params.combination_key = rowData.COMBINATION_KEY;
    params.trans_type_key = mainData[0].editrows[0][0].trans_type_key;

    // Include checkLockedbj from rowData - match AngularJS format exactly
    const checkLockedbj = [{
      "leid": rowData.LEID,
      "me_code": rowData.ME,
      "combination_key": rowData.COMBINATION_KEY
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // MUST use application/x-www-form-urlencoded (NOT application/json):
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = baseUrl + "/saveJsonObject?action_code=nkepph";
    
    // Save form data
    const saveForm = this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });

    // Save diagnostic data if exists
    if (diagData && diagData.length > 0) {
      const diagParams: any = {
        diag_exception: JSON.stringify(diagData),
        tax_year: filterParams.tax_year || params.tax_year || rowData.TAX_YEAR,
        screen_key: filterParams.screen_key || '',
        scenario: filterParams.scenario || params.scenario || rowData.SCENARIO,
        jcd_key: filterParams.jcd_key || params.jcd_key || rowData.JCD_KEY || 250,
        scenarioCode: filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF",
        is_issue_key_enabled: "N"
      };

      // Merge with global params (order matters - diagParams should override)
      const diagFullParams = _.merge({}, globalService?.globalParams || {}, filterParams, diagParams);

      const diagUrlEncoded = new URLSearchParams();
      Object.keys(diagFullParams).forEach(key => {
        if (diagFullParams[key] !== undefined && diagFullParams[key] !== null) {
          diagUrlEncoded.set(key, diagFullParams[key].toString());
        }
      });

      const saveDiagURL = baseUrl + "/saveJsonObject?action_code=ftmltp";
      const saveDiag = this.http.post<any>(saveDiagURL, diagUrlEncoded.toString(), { headers, withCredentials: true });

      // Execute both save operations in parallel
      return forkJoin([saveForm, saveDiag]).pipe(
        map(([formResponse, diagResponse]) => {
          // Return the form response as the main response
          return formResponse;
        })
      );
    } else {
      // Only save form data
      return saveForm;
    }
  }
}

